import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const BusinessEntityAdvisorResultsRoot = superstyled({
  name: 'BusinessEntityAdvisorResults',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  })
});

export const ReportHeader = superstyled({
  name: 'BusinessEntityAdvisorResults',
  slot: 'ReportHeader',
  tag: Box,
  styles: () => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  })
});

export const ReportContent = superstyled({
  name: 'BusinessEntityAdvisorResults',
  slot: 'ReportContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })
});
